import { render } from "./settingsSvg.vue?vue&type=template&id=324a0233&scoped=true"
import script from "./settingsSvg.vue?vue&type=script&lang=js"
export * from "./settingsSvg.vue?vue&type=script&lang=js"

import "./settingsSvg.vue?vue&type=style&index=0&id=324a0233&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sebastian\\Desktop\\-taptasty-order\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324a0233"]])

export default __exports__